import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Aura from '@primeuix/themes/aura'
import 'primeicons/primeicons.css'
import './styles.css'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(PrimeVue, {
    theme: { preset: Aura, options: { darkModeSelector: '.dark-mode' } },
    ripple: true,
  })
  .use(ToastService)
  .use(ConfirmationService)
  .mount('#app')

